import React from 'react';
import styled from 'styled-components';


interface ITravellerPhoto {
  source: string;
  text: string;
  alternateText: string;
  noOfPhotos: number;
}

const TravellerPhotoUpload = ({source, text, alternateText, noOfPhotos}) => (
  <>
    <GallerySmallWrap>
      <GallerySmallImg src={source} alt={alternateText} itemProp="image" />
    </GallerySmallWrap>
    <GalleryInfoOverlay>
      <OverlayText>Hotelier Images</OverlayText>
    </GalleryInfoOverlay>
  </>
);

export default TravellerPhotoUpload;


export const GallerySmallWrap = styled.div(
  props => `
      width: 100%;
      display: flex;
      position: relative;
      height: 19rem;
      margin-bottom: ${props.theme.spacing.base};  
      box-shadow: 0 4px 8px 0 rgba(138, 107, 118, 0.08);
      border: solid 0.5px ${props.theme.colors.grey.lightdd};
  `
);

export const GallerySmallImg = styled.img(
  props => `
      width: 31.9rem;
      height: 18.9rem;
      // object-fit: contain;
  `
);

export const GalleryInfoOverlay = styled.div(
  props => `
      width:100%;
      display: flex;
      // // background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000);
      background: #000000;
      height: 3rem;
      // padding: ${props.theme.spacing.large.l20};
      position: absolute;
      bottom: 0;
      // left:0;  
      justify-content: center;
      align-items: center;
      border-left: solid 0.5px ${props.theme.colors.grey.lightdd};
      // // align-items: flex-end;
  `
);

export const OverlayText = styled.p(
  props => `
      font-size: ${props.theme.font.base};
      color: ${props.theme.colors.white.base};
      font-weight: ${props.theme.font.fontWeight.bold};
      text-transform: ${props.theme.font.textTransform.upper};
  `
);